function sortSizeList($selector, $container) {
  $selector.each(function (i, item) {
      sizeClothing = $(item).find(".swatch-element").data("value");
      sizeFootwear = $(item).find(".swatch-element").data("value");

      switch ((sizeClothing, sizeFootwear)) {
        //! Roupas
        case "2XP":
          item.setAttribute("data-id", "1");
          break;

        case "XP":
          item.setAttribute("data-id", "2");
          break;

        case "P":
          item.setAttribute("data-id", "3");
          break;

        case "M":
          item.setAttribute("data-id", "4");
          break;

        case "G":
          item.setAttribute("data-id", "5");
          break;

        case "GG":
          item.setAttribute("data-id", "6");
          break;

        case "2XG":
          item.setAttribute("data-id", "7");
          break;

        case "3XG":
          item.setAttribute("data-id", "8");
          break;

        //! Calçados
        case "32":
          item.setAttribute("data-id", "32");
          break;

        case "33":
          item.setAttribute("data-id", "33");
          break;

        case "34":
          item.setAttribute("data-id", "34");
          break;

        case "35":
          item.setAttribute("data-id", "35");
          break;

        case "36":
          item.setAttribute("data-id", "36");
          break;

        case "37":
          item.setAttribute("data-id", "37");
          break;

        case "38":
          item.setAttribute("data-id", "38");
          break;

        case "39":
          item.setAttribute("data-id", "39");
          break;

        case "40":
          item.setAttribute("data-id", "40");
          break;

        case "41":
          item.setAttribute("data-id", "41");
          break;

        case "42":
          item.setAttribute("data-id", "42");
          break;

        case "43":
          item.setAttribute("data-id", "43");
          break;

        case "44":
          item.setAttribute("data-id", "44");
          break;
      }
    });

  let sizeList = $selector;

  sizeList.sort(function (a, b) {
    return $(a).attr("data-id") - $(b).attr("data-id");
  });

  $container.html(sizeList);
}

var $selector;
var $container;

$(document).ready(function () {
  setTimeout(() => {
    $selector = $(".product_section .shopify-product-form .swatch_options .swatch.is-size .swatch__container").find(".swatch__item");
    $container = $(".product_section .shopify-product-form .swatch_options .swatch.is-size .swatch__container")
    sortSizeList($selector, $container);
  }, 1000);
});

$(".js-quick-shop-link").on("click", function () {
    setTimeout(() => {
        $selector = $(".six.columns .swatch_options .swatch.is-size .swatch__container").find(".swatch__item")
        $container = $(".six.columns .swatch_options .swatch.is-size .swatch__container");
        sortSizeList($selector, $container);
    }, 2000);
});
